import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { SelectedCustomerSelector } from './customer.selectors';
export var BillingPaymentsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.billingPayments;
});
export var IsFutureInvoicesCalcultaionStartedSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.futureInvoicesDetails.startCalculating;
});
export var FutureInvoicesCalculationSessionIdSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.futureInvoicesDetails.calculationSessionId;
});
export var FutureInvoicesDataSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  var $filter = getFilterService();
  return billingPayments.futureInvoicesDetails.invoices.map(function (invoice) {
    var _invoice$CaseId;
    return {
      amountWithCurrency: invoice.EstimatedAmount ? $filter('invCurrency')(invoice.EstimatedAmount, invoice.CurrencyCode) : $filter('invCurrency')(0, invoice.CurrencyCode),
      currencyCode: invoice.CurrencyCode,
      endDate: $filter('localShort')(invoice.EndDate),
      estimatedAmount: invoice.EstimatedAmount,
      hasOpenDispute: !!((_invoice$CaseId = invoice.CaseId) !== null && _invoice$CaseId !== void 0 && _invoice$CaseId.Value || invoice.HasOpenLineItemDispute),
      invoiceDateTime: $filter('shortWithSeconds')(invoice.InvoiceDateTime),
      invoiceId: invoice.InvoiceId,
      startDate: $filter('localShort')(invoice.StartDate),
      startToEndDate: "".concat($filter('localShortDate')(invoice.StartDate), " - ").concat($filter('localShortDate')(invoice.EndDate))
    };
  });
});
export var FutureInvoicesCalculationStatusSelector = createImmutableSelector([BillingPaymentsSelector], function (billingPayments) {
  return billingPayments.futureInvoicesDetails.status;
});